// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedBlockHeader_container__3lSbw","blockHeader":"SelectedBlockHeader_blockHeader__xn9yT","blockHeaderWithTitle":"SelectedBlockHeader_blockHeaderWithTitle__2AV9F"};